export const IS_REDESIGN_ENABLED = 'aud_mobile_acti187_new_home';

export const EXPERIMENTS: string[] = [IS_REDESIGN_ENABLED];
